// @flow

import React from 'react'
import Modal from 'components/shared/Modal'
import PhoneVerificationView from 'components/molecules/PhoneVerificationView'
import { type User as UserType } from 'types/user'

type Props = {
  user: UserType,
  hasConfirmedPhone: boolean,
  title: string,
  fromText: string,
  submitButtonText: String,
  isSubmitButtonDisabled: boolean,
  isAlreadySavedContact: boolean,
  sentPhoneNumber: string,
  sentSms: boolean,
  onClickClose: (e: Event) => void,

  sendError: string,
  verifyError: string,

  industries: Array<*>,
  largeAreas: Array<*>,
  jobs: Array<*>,

  familyName: {
    value?: ?string,
    onChange: (e: SyntheticInputEvent<*>) => void,
    error?: ?string,
  },
  givenName: {
    value?: ?string,
    onChange: (e: SyntheticInputEvent<*>) => void,
    error?: ?string,
  },
  corpName: {
    value?: ?string,
    onChange: (e: SyntheticInputEvent<*>) => void,
    error?: ?string,
  },
  department: {
    value?: ?string,
    onChange: (e: SyntheticInputEvent<*>) => void,
    error?: ?string,
  },
  industry: {
    value?: ?string,
    onChange: (e: Event) => void,
    error?: ?string,
  },
  job: {
    value?: ?string,
    onChange: (e: Event) => void,
    error?: ?string,
  },
  phone: {
    value: string,
    onChange: (e: SyntheticInputEvent<*>) => void,
  },
  code: {
    value: string,
    onChange: (e: SyntheticInputEvent<*>) => void,
  },

  onClickSendPhoneNumber: Function,
  onClickBackToPhoneNumber: Function,
  onClickMakeCall: Function,
  onClickSendVerifyCode: Function,
  onClickToInquiry: Function,
}

const FormValidationMessage = (props: { errorText?: ?string }) => {
  if (props.errorText !== null && props.errorText !== '') {
    return (
      <p className="popup-form__required is-error">
        <i className="fa fa-exclamation-circle" />
        {props.errorText}
      </p>
    )
  }

  return null
}

export default function UserContactModal(props: Props) {
  return (
    <Modal onClickClose={props.onClickClose} isScrollLock>
      <div className="md-content">
        <div className="page__popup">
          <form>
            <div className="page__popup-col1">
              <div className="popup-headline">
                <h2 className="popup-headline__title">{props.title}</h2>
                <p className="popup-headline__text">
                  {i18n.t('userContact.description.0', {
                    fromText: props.fromText,
                  })}
                  <br className="sm-hide" />
                  {i18n.t('userContact.description.1', {
                    submitButton: props.submitButtonText,
                  })}
                </p>
              </div>
              <div className="row">
                {!props.isAlreadySavedContact && (
                  <div>
                    <div className="odd-col__line clearfix">
                      <div className="col-md-3">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__required">
                            {i18n.t('page.shared.l_00030')}
                          </span>
                          <span className="popup-form__title-text">
                            {i18n.t('userContact.name.title')}
                          </span>
                        </h2>
                      </div>
                      <div className="col-md-9">
                        <div className="information-name">
                          <label>
                            <span className="popup-form__label">
                              {i18n.t('userContact.name.family')}
                            </span>
                            <input
                              name="contact[family_name]"
                              type="text"
                              className="form-text servicse-form-text"
                              value={props.familyName.value}
                              onChange={props.familyName.onChange}
                            />
                            <FormValidationMessage
                              errorText={props.familyName.error}
                            />
                          </label>
                        </div>
                        <div className="information-name">
                          <label>
                            <span className="popup-form__label">
                              {i18n.t('userContact.name.given')}
                            </span>
                            <input
                              name="contact[given_name]"
                              type="text"
                              value={props.givenName.value}
                              onChange={props.givenName.onChange}
                              className="form-text servicse-form-text"
                            />
                            <FormValidationMessage
                              errorText={props.givenName.error}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-md-3">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__optional">
                            {i18n.t('page.shared.l_00031')}
                          </span>
                          <span className="popup-form__title-text">
                            {i18n.t('userContact.corpName.title')}
                          </span>
                        </h2>
                      </div>
                      <div className="col-md-9">
                        <input
                          name="contact[corp_name]"
                          type="text"
                          value={props.corpName.value}
                          onChange={props.corpName.onChange}
                          placeholder={i18n.t(
                            'userContact.corpName.placeholder',
                          )}
                          className="form-text servicse-form-text w100pa"
                        />
                        <FormValidationMessage
                          errorText={props.corpName.error}
                        />
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-md-3">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__optional">
                            {i18n.t('page.shared.l_00031')}
                          </span>
                          <span className="popup-form__title-text">
                            {i18n.t('userContact.department.title')}
                          </span>
                        </h2>
                      </div>
                      <div className="col-md-9">
                        <input
                          name="contact[department]"
                          type="text"
                          value={props.department.value}
                          onChange={props.department.onChange}
                          placeholder={i18n.t(
                            'userContact.department.placeholder',
                          )}
                          className="form-text servicse-form-text w100pa"
                        />
                        <FormValidationMessage
                          errorText={props.department.error}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <div className="odd-col__line clearfix phone-verification">
                  <div className="col-md-3">
                    <h2 className="popup-form__title">
                      <span className="icon-form icon-form__required">
                        {i18n.t('page.shared.l_00030')}
                      </span>
                      <span className="popup-form__title-text">
                        {i18n.t('phoneVerification.title')}
                      </span>
                    </h2>
                  </div>
                  <div className="col-md-9">
                    <PhoneVerificationView
                      sentPhoneNumber={props.sentPhoneNumber}
                      sentSms={props.sentSms}
                      phoneNumber={props.phone.value}
                      sendError={props.sendError}
                      verificationCode={props.code.value}
                      verifyError={props.verifyError}
                      confirmedPhone={props.hasConfirmedPhone}
                      onChangePhoneNumber={props.phone.onChange}
                      onChangeVerifyCode={props.code.onChange}
                      onClickSendPhoneNumber={props.onClickSendPhoneNumber}
                      onClickBackToPhoneNumber={props.onClickBackToPhoneNumber}
                      onClickMakeCall={props.onClickMakeCall}
                      onClickSendVerifyCode={props.onClickSendVerifyCode}
                    />
                  </div>
                </div>
                <div className="odd-col__line clearfix">
                  <div className="ta-c mt20 mb20 clearfix">
                    <div className="popup-form__submit-btn">
                      <input
                        onClick={props.onClickToInquiry}
                        type="button"
                        name="commit"
                        value={props.submitButtonText}
                        className={`button-${
                          props.isSubmitButtonDisabled ? 'disabled' : 'blue'
                        } request-submit`}
                        disabled={props.isSubmitButtonDisabled}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/UserContactModal/index.jsx